import { useState } from 'react';
import { Tooltip, Typography } from '@mui/material';
import { classnameIcon, generarteHeight, generateBlod, generateWidthPreview } from '../../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DialogPreviewFile from '../dialog/DialogPreviewFile';
import IconTooltipButton from '../button/IconTooltipButton';

const ChipMediaFeed = ({ data = {}, onDelete, disabled, simple, error }) => {
  const [show, setShow] = useState(false);
  const width = generateWidthPreview(data.mimetype);
  const height = generarteHeight(data.mimetype);
  const size = simple ? 9 : 14;
  const label = data.description ? data.description : data.name;

  const onClick = (e) => {
    e.stopPropagation();
    if (disabled) return;
    if (data.type === 'file') {
      setShow(true);
    }
  };
  return (
    <>
      {show && (
        <DialogPreviewFile
          width={width}
          height={height}
          data={data}
          show={show}
          onClose={(e) => {
            e.stopPropagation();
            setShow(false);
          }}
        />
      )}
      <Tooltip arrow placement='top' title={error ? error : label}>
        <div className={['flex items-center gap-2 cursor-pointer bg-loading  px-2 py-1 border rounded-lg',
          error ? 'border-error bg-destructive-foreground' : 'border-muted  bg-loading bg-clickeabled',
        ].join(' ')} onClick={onClick}>
        <div className='flex items-center gap-2'>
          <div
              className='p-1 rounded-full flex items-center justify-center'
              style={{
                width: size,
                height: size,
                margin: 0,
                backgroundColor: classnameIcon(data.mimetype, error ? 'error' : data.type)
              }}
            >
              <FontAwesomeIcon
                style={{ fontSize: simple ? '0.95em' : '1.2em' }}
                className='text-white'
                icon={generateBlod(data.mimetype, error ? 'error' : data.type)}
              />
            </div>

          <Typography
              noWrap
              className={['text-ellipsis', simple ? 'text-xs' : 'text-sm'].join(' ')}
              component={data.type === 'link' ? 'a' : 'span'}
              href={data.link}
              target='_blank'
            >
              {label}
            </Typography>
        </div>
            {onDelete && (
              <IconTooltipButton
                disabled={disabled}
                title='Delete attachment'
                size='small'
                variant='circle'
                className='text-xs p-0.5 ml-2'
                style={{ fontSize: simple ? '0.7em' : '0.9em' }}
                icon={['fas', 'times']}
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(data);
                }}
              />
            )}
        </div>

      </Tooltip>
    </>
  );
};

export default ChipMediaFeed;
